// extracted by mini-css-extract-plugin
export var content = "_o0-1";
export var fullScreen = "_o0-0";